<button [attr.id]="buttonId()"
        tdWbButton
        [tdWbButtonType]="buttonType()"
        (click)="onClick()">
  <span [translate]="'tdWb.core.viewMore.' + (showViewLess ? 'LESS' : 'MORE')"></span>
  <td-wb-icon [iconId]="'chevron-' + (showViewLess ? 'up' : 'down')"
              [inline]="true"
              [size]="size()" />
</button>
